export const LOCATION = '@lex-content/location'
export const FORM_ORIGIN = '@lex-content/form-origin'
